<template>
    
    <div 
        v-if="healthAndSafetyData && healthAndSafetyData.length > index"
    >
        <!-- {{healthAndSafetyData[index]}} -->
            <div 
            v-b-tooltip.hover
            :title="healthAndSafetyData[index].task_title"
            >
            <span v-if="healthAndSafetyData[index].task_status == '0'">
                <font-awesome-icon
                size="lg"
                icon="hourglass-half"
                />
            </span>
            <span v-else-if="healthAndSafetyData[index].task_status == '1'">
                <font-awesome-icon
                size="lg"
                icon="hourglass-half"
                />
            </span>
            <b-badge
                v-else-if="healthAndSafetyData[index].task_status == '2'"
                variant="danger"
            >On hold</b-badge>
            <b-badge
                v-else-if="healthAndSafetyData[index].task_status == '3'"
                variant="dark"
            >Review</b-badge>
            <span
                class="text-success"
                v-else-if="healthAndSafetyData[index].task_status == '4'"
            >
                <font-awesome-icon
                size="lg"
                icon="check-circle"
                />
            </span>
            <div class="text-center">
                <span class="" v-if="healthAndSafetyData[index].version==null">
                  {{createdAtDate(healthAndSafetyData[index].created_at)}}
                </span>
                <span class="" v-else>
                  {{createdAtDate(healthAndSafetyData[index].created_at)}} ({{healthAndSafetyData[index].version}})
                </span>
            </div>
            </div>
    </div>
</template>

<script>
import moment from "moment";
import "moment/locale/es";

export default {
  name: "DynamicTrainingAndPolicyColumns",
  props: {
    index: Number,
    healthAndSafetyData: Array
  },
  methods:{
    createdAtDate ( value ) {
      moment.locale( "en" );
    //   console.log(this.healthAndSafetyData,"healthAndSafetyData")
    //   https://ethixbase.atlassian.net/browse/EB2-51025
      return moment( value ).format( "MMM YYYY" );
    },
  }
}
</script>
